import { render, staticRenderFns } from "./RecommendSimilars.vue?vue&type=template&id=1272b4ae&scoped=true&"
import script from "./RecommendSimilars.vue?vue&type=script&lang=js&"
export * from "./RecommendSimilars.vue?vue&type=script&lang=js&"
import style0 from "./RecommendSimilars.vue?vue&type=style&index=0&id=1272b4ae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1272b4ae",
  null
  
)

export default component.exports